import axios from 'axios';
import {clarify} from "../utils/clear";

class UserApi {
    constructor() {
        this.endpoint = process.env.VUE_APP_BASE_API;
    }

    /* eslint-disable no-unused-vars */
    list(body) {
        let params = new URLSearchParams(clarify(body));
        // for (let [key, val] of addParams.entries()) {
        //     params.append(key, val);
        // }
        return axios.get(`${this.endpoint}/user`, {params}).then(response => response.data);
    }

    excel(body, prefix, suffix) {
        let params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/user/excel`, {
            params,
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/vnd.ms-excel'
            }
        }).then(response => {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)

            link.download = prefix + ' 회원목록'+suffix+'.xlsx'
            link.click()
            URL.revokeObjectURL(link.href)
        });

    }

    get(userId) {
        return axios.get(`${this.endpoint}/user/get/${userId}`, {}).then(response => response.data);
    }

    groupUsers(body) {
        const params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/user/group/users`, {params}).then(response => response.data);
    }

    stateList() {
        return axios.get(`${this.endpoint}/user/state/list`, {}).then(response => response.data);
    }

    exists(userId) {
        return axios.get(`${this.endpoint}/user/exists/${userId}`, {}).then(response => response.data);
    }
    existsMobile(mobileNo) {
        return axios.get(`${this.endpoint}/user/mobile/exists/${mobileNo}`, {}).then(response => response.data);
    }
    existsEmail(email) {
        return axios.get(`${this.endpoint}/user/email/exists/${email}`, {}).then(response => response.data);
    }

    save(user) {
        return axios.post(`${this.endpoint}/user/save`, user).then(response => response.data);
    }

    delete(userId) {
        return axios.delete(`${this.endpoint}/user/delete?userId=${userId}`, {}).then(response => response.data);
    }

    setPosition(position, userId, groupId) {
        return axios.post(`${this.endpoint}/user/position`, {
            position: position,
            userId: userId,
            groupId: groupId
        }).then(response => response.data);
    }

    updateState(users, state) {
        return axios.put(`${this.endpoint}/user/state/update/${state}`, users);
    }
    updateStateAll(body, state) {
        return axios.put(`${this.endpoint}/user/state/update/all/${state}`, body);
    }
    updateUserGroupState(state, groupId, userId) {
        return axios.put(`${this.endpoint}/user/${userId}/group/${groupId}/state/update/${state}`);
    }

}


export default new UserApi();
